import Box from '@mui/material/Box';
import type {SxProps} from '@mui/system';
import type {FC, ReactNode} from 'react';

//TYPES
type Props = {
  children?: ReactNode;
};

const CenteredLayout: FC<Props> = ({children}) => {
  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.content}>{children}</Box>
    </Box>
  );
};
export default CenteredLayout;

const styles: Record<string, SxProps> = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    bgcolor: 'background.semiTransparent',
    borderColor: 'primary.main',
    borderWidth: '6px',
    borderStyle: 'double',
  },
  wrapper: {
    margin: 'auto',
  },
};
